<template>
  <div class="center-loader" v-if="loading">
    <LoadingSection />
  </div>
  <div class="container-activated" v-else>
    <div v-if="checked">
      ¡Tu Email ha sido cambiado con éxito pincha
      <a
        :href="
          $router.resolve({
            name: 'LoginPage',
          }).href
        "
        >aquí</a
      >
      para iniciar sesión en tu empresa.
    </div>
    <div v-else>
      {{ bad_message }}
      <a
        :href="
          $router.resolve({
            name: 'LoginPage',
          }).href
        "
        >regresar al login</a
      >
    </div>
  </div>
</template>

<script>
import LoadingSection from "../../../components/loaderGeneric/Loading.vue";
import authService from "../services/authService";

export default {
  components: {
    LoadingSection,
  },
  computed: {},
  created() {
    this.validNewEmail();
  },
  props: {
    some_token: {
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      checked: false,
      bad_message: "",
    };
  },
  methods: {
    validNewEmail() {
      authService
        .verify_account(this.some_token)
        .then(() => {
          this.loading = false;
          this.checked = true;
          setTimeout(() => {
            this.$store.dispatch("Login/logOut", null);
          }, 2500);
        })
        .catch(() => {
          this.bad_message = "Error al activar su email token no valido";
          this.checked = false;
          this.loading = false;
        });
    },
  },
  watch: {},
};
</script>

<style>
.container-activated {
  align-items: center;
  /* margin: 0 auto; */
  display: flex;
  justify-content: center;
  /* align-self: center; */
  height: 100vh;
  /* margin-bottom: 5rem; */
  padding-bottom: 5rem;
}
</style>
